"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piove-di-sacco": {
    "286c9c9b": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "skipSearch": false
    }],
    "albora": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "501c856b": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d013994": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "skipSearch": false
    }],
    "mareggia": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4455c2b5": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "skipSearch": false
    }],
    "negrisolo": [{
      "hkey": "7b3dfbe2",
      "slug": "piove-di-sacco",
      "name": "Piove di Sacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;